var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page home"},[_c('HomeHero'),_c('HomeNews1'),_c('HomeHyjy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }